import React, { useCallback, useState } from 'react';

import PropTypes from 'prop-types';
import { Button, InputControlLabel } from '@picsio/ui';

import withErrorBoundary from '../ErrorBoundary/withErrorBoundary';
import Icon from '../Icon';
import l18n from '../../shared/strings';
import s from './styles.module.scss';

function KeepMediaConsistentDialog({
  onAddToListingAndMaster,
  onAddToListingOnly,
  onCancel,
}) {
  const strings = l18n.DIALOGS.KEEP_MEDIA_CONSISTENT;
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleDontShowChange = useCallback(() => {
    setDontShowAgain((prev) => !prev);
  }, []);

  const handleListingAndMaster = useCallback(() => {
    onAddToListingAndMaster({ dontShowAgain });
  }, [dontShowAgain, onAddToListingAndMaster]);

  const handleListingOnly = useCallback(() => {
    onAddToListingOnly({ dontShowAgain });
  }, [dontShowAgain, onAddToListingOnly]);

  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <div className={`simpleDialog ${s.dialog}`}>
      <div className="simpleDialogUnderlayer" />
      <div className="simpleDialogBox">
        <div className="simpleDialogHeader">
          <h2 className="simpleDialogTitle">{strings.TITLE}</h2>
          <button
            className="simpleDialogBtnCross"
            type="button"
            onClick={handleCancel}
          >
            <Icon name="close" />
          </button>
        </div>
        <div className="simpleDialogContent">
          <div className={`simpleDialogContentInner ${s.contentInner}`}>
            <div className={s.description}>{strings.DESCRIPTION}</div>
            <div className={s.checkbox}>
              <InputControlLabel
                id="keep-media-consistent-dont-show"
                name="keepMediaConsistentDontShow"
                control="checkbox"
                label={strings.DONT_SHOW_AGAIN}
                value={dontShowAgain}
                ControlProps={{ 'data-testid': 'chkKeepMediaConsistentDontShow' }}
                onChange={handleDontShowChange}
              />
            </div>
          </div>
        </div>
        <div className={`simpleDialogFooter ${s.footer}`}>
          <Button
            color="secondary"
            size="md"
            variant="contained"
            componentProps={{ 'data-testid': 'btnKeepMediaConsistentCancel' }}
            onClick={handleCancel}
          >
            {strings.BTN_CANCEL}
          </Button>
          <Button
            color="secondary"
            size="md"
            variant="contained"
            componentProps={{ 'data-testid': 'btnKeepMediaConsistentListingOnly' }}
            onClick={handleListingOnly}
          >
            {strings.BTN_LISTING_ONLY}
          </Button>
          <Button
            color="primary"
            size="md"
            variant="contained"
            componentProps={{ 'data-testid': 'btnKeepMediaConsistentListingAndMaster' }}
            onClick={handleListingAndMaster}
          >
            {strings.BTN_LISTING_AND_MASTER}
          </Button>
        </div>
      </div>
    </div>
  );
}

KeepMediaConsistentDialog.propTypes = {
  onAddToListingAndMaster: PropTypes.func.isRequired,
  onAddToListingOnly: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default withErrorBoundary(KeepMediaConsistentDialog, {
  className: 'errorBoundaryOverlay',
});
